'use client';

import {useId} from 'react';
import {Input} from '@/matic/components/ui/input';

type TextFieldProps = {
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
  label: string;
  required?: boolean;
};

export function TextField({
  value,
  onChange,
  error,
  disabled,
  label,
  required,
}: TextFieldProps) {
  const id = useId();
  const stringValue = typeof value === 'string' ? value : '';

  return (
    <div>
      <label
        htmlFor={id}
        className="mb-1 block text-sm font-medium text-gray-700"
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      <Input
        id={id}
        type="text"
        value={stringValue}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        disabled={disabled}
        className={error ? 'border-red-500' : ''}
      />
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}
